<template lang="pug">
  v-container
    v-row
      v-text-field(
        v-model='search' 
        prepend-icon='fa-search' 
        label='Buscar' 
        single-line hide-details
      )
      dataPickerCombobox(type='Outputs')
      
    v-row 
      v-col
        v-data-table.elevation-1( 
          :headers="headers" 
          :items="outputsRecord" 
          :search='search' 
          :loading='outputs.loading' 
          :footer-props="footerProps"
          :options.sync="options"
          v-model="elementos_seleccionados"
          show-select
          item-key="numero_de_operacion"
          :server-items-length='outputs.cantidad_de_registros'

        )
          template( v-slot:top )
            v-toolbar( flat color="white")
              v-toolbar-title Notas de Salida
              v-spacer
              MassiveOutputDialog
              formulario_maestro( modelo='Outputs' )

          template( v-slot:item.total = '{item}')
            v-chip(v-if='item.total') {{ Number(item.total).toFixed(2) }}
            

          template( v-slot:item.comprobante_serie_numero="{item}")
            v-chip(small  v-if='item.comprobante_serie_numero' outlined  color='primary' target='_blank' :href='item.vinculo_comprobante') {{item.comprobante_serie_numero}}
            v-chip(small  v-if='item.comprobante_reversion_serie_numero' outlined  color='primary' target='_blank' :href='item.vinculo_comprobante_reversion') {{item.comprobante_reversion_serie_numero}} 
            v-chip.my-1(small v-if='item.guia_serie_numero' outlined  color='secondary' target='_blank' :href='item.vinculo_guia') {{item.guia_serie_numero}}

          template( v-slot:item.estado_del_documento="{item}")
            ListaDeAcciones(modelo='Outputs' :estado_del_documento = 'item.estado_del_documento' :id = 'item.id' :mensaje = 'item.mensaje' )
          
          template( v-slot:item.nombre_motivo_de_traslado='{item}')
            span {{ item.nombre_motivo_de_traslado }}
            p.ma-0
              v-chip(x-small outlined color='primary') {{item.almacén_de_origen }}
              v-icon.mx-1(v-if='item.almacén_de_destino' x-small) fa-arrow-right
              v-chip(v-if='item.almacén_de_destino' x-small outlined) {{item.almacén_de_destino}}

        
       
    v-row
      v-btn.mt-3(@click='proceso_masivo({elementos_seleccionados, tipo_de_operacion:"salida" })' :disabled='elementos_seleccionados.length==0' rounded color='primary') Proceso Masivo
      printerButtons(:dataToPrint = 'outputsRecord')
        
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  data: ()=>({
  
    registerDialog: false,
    search: '',
    headers: [
      { text: 'Nº',                   value: 'numero_de_operacion' },       
      { text: 'Motivo',               value: 'nombre_motivo_de_traslado' },
      { text: 'Cliente',              value: 'cliente_denominacion' },   
      { text: 'Fecha',                value: 'fecha_de_emision' },
      { text: 'Total',                value: 'total' },
      { text: 'Comprobante',          value: 'comprobante_serie_numero' },
      { text: '',          value: 'estado_del_documento' },

      
    ],
    options: {},
    footerProps: {
      'items-per-page-options':    [15, 50, 500]
    },
    elementos_seleccionados:[]
  }),
  methods:{
    ...mapActions ({
      obtener_todo: 'Outputs/obtener_todo',
      proceso_masivo: 'Kardex/proceso_masivo'
    }), 
  },
  computed:{ 
    ...mapGetters({
      outputsRecord: 'Outputs/registro',
    }),
    ...mapState({
      outputs: state=>state.Outputs,
      db_activada: state=>state.Customers.db_activada,
    })
  },  
  watch:{
    'db_activada'(){
      this.obtener_todo({itemsPerPage: 15, page: 1})         
    },
    options: {
      handler () {
        this.obtener_todo(this.options)
      },
      deep: true,
    },
 
  },
  created(){
    if(this.db_activada) this.obtener_todo({itemsPerPage: 10, page: 1})          
  },
  components:{
    formulario_maestro: ()=>import('@/components/formulario_maestro'),
    MassiveOutputDialog: () => import('.././componentes/massiveOutputDialog'),
    dataPickerCombobox: ()=>import('.././componentes/dataPickerCombobox'),
    printerButtons: ()=>import('.././componentes/printerButtons'),
    ListaDeAcciones: () => import('@/components/lista_de_acciones')
  }
}
</script>

